import { createFileRoute } from "@tanstack/react-router";
import { DisposalView } from "../../app/views/lineCheck/disposalView";

export const Route = createFileRoute("/disposal/dispose")({
  component: DisposalView,
});
